/** Yankı — embeddable game contract (docs/design/platform.md): the shell starts these scenes in its own Phaser game. */
import type Phaser from "phaser";
import { levelMapScene } from "@kit/map";
import { track } from "@kit/telemetry";
import { levelSpec } from "./core/game";
import { meta } from "./meta";
import { YankiScene } from "./YankiScene";

const YankiMap = levelMapScene({
  id: "yanki",
  gameScene: "yanki",
  title: { tr: "Yankı", en: "Echo" },
  accent: 0x2ec4b6,
  firstTheme: 2,
  track,
  describe: (n, lang) => {
    const s = levelSpec(n);
    const len = `${s.start}–${s.start + s.rounds - 1}`;
    if (lang === "tr") return s.reverse ? `TERS YANKI: ${len} işaret, sondan başa · hatasız 3 yıldız` : `${len} işaretlik dizi · hatasız 3 yıldız`;
    return s.reverse ? `REVERSE ECHO: ${len} symbols, last to first · no mistakes for 3 stars` : `${len}-symbol sequence · no mistakes for 3 stars`;
  },
});

export const game: { meta: typeof meta; scenes: Phaser.Types.Scenes.SceneType[] } = {
  meta,
  scenes: [YankiMap, YankiScene],
};
